<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "partial" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 22 22'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M20.2 21C20.48 21 20.62 21 20.727 20.9455C20.8211 20.8976 20.8976 20.8211 20.9455 20.727C21 20.62 21 20.48 21 20.2V9.8C21 9.51997 21 9.37996 20.9455 9.27301C20.8976 9.17893 20.8211 9.10244 20.727 9.0545C20.62 9 20.48 9 20.2 9L17.8 9C17.52 9 17.38 9 17.273 9.0545C17.1789 9.10243 17.1024 9.17892 17.0545 9.27301C17 9.37996 17 9.51997 17 9.8V12.2C17 12.48 17 12.62 16.9455 12.727C16.8976 12.8211 16.8211 12.8976 16.727 12.9455C16.62 13 16.48 13 16.2 13H13.8C13.52 13 13.38 13 13.273 13.0545C13.1789 13.1024 13.1024 13.1789 13.0545 13.273C13 13.38 13 13.52 13 13.8V16.2C13 16.48 13 16.62 12.9455 16.727C12.8976 16.8211 12.8211 16.8976 12.727 16.9455C12.62 17 12.48 17 12.2 17H9.8C9.51997 17 9.37996 17 9.273 17.0545C9.17892 17.1024 9.10243 17.1789 9.0545 17.273C9 17.38 9 17.52 9 17.8V20.2C9 20.48 9 20.62 9.0545 20.727C9.10243 20.8211 9.17892 20.8976 9.273 20.9455C9.37996 21 9.51997 21 9.8 21L20.2 21Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
        <path
            d = 'M9 5.8C9 5.51997 9 5.37996 9.0545 5.273C9.10243 5.17892 9.17892 5.10243 9.273 5.0545C9.37996 5 9.51997 5 9.8 5H12.2C12.48 5 12.62 5 12.727 5.0545C12.8211 5.10243 12.8976 5.17892 12.9455 5.273C13 5.37996 13 5.51997 13 5.8V8.2C13 8.48003 13 8.62004 12.9455 8.727C12.8976 8.82108 12.8211 8.89757 12.727 8.9455C12.62 9 12.48 9 12.2 9H9.8C9.51997 9 9.37996 9 9.273 8.9455C9.17892 8.89757 9.10243 8.82108 9.0545 8.727C9 8.62004 9 8.48003 9 8.2V5.8Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
        <path
            d = 'M2 11.8C2 11.52 2 11.38 2.0545 11.273C2.10243 11.1789 2.17892 11.1024 2.273 11.0545C2.37996 11 2.51997 11 2.8 11H5.2C5.48003 11 5.62004 11 5.727 11.0545C5.82108 11.1024 5.89757 11.1789 5.9455 11.273C6 11.38 6 11.52 6 11.8V14.2C6 14.48 6 14.62 5.9455 14.727C5.89757 14.8211 5.82108 14.8976 5.727 14.9455C5.62004 15 5.48003 15 5.2 15H2.8C2.51997 15 2.37996 15 2.273 14.9455C2.17892 14.8976 2.10243 14.8211 2.0545 14.727C2 14.62 2 14.48 2 14.2V11.8Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
        <path
            d = 'M1 1.8C1 1.51997 1 1.37996 1.0545 1.273C1.10243 1.17892 1.17892 1.10243 1.273 1.0545C1.37996 1 1.51997 1 1.8 1H4.2C4.48003 1 4.62004 1 4.727 1.0545C4.82108 1.10243 4.89757 1.17892 4.9455 1.273C5 1.37996 5 1.51997 5 1.8V4.2C5 4.48003 5 4.62004 4.9455 4.727C4.89757 4.82108 4.82108 4.89757 4.727 4.9455C4.62004 5 4.48003 5 4.2 5H1.8C1.51997 5 1.37996 5 1.273 4.9455C1.17892 4.89757 1.10243 4.82108 1.0545 4.727C1 4.62004 1 4.48003 1 4.2V1.8Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>